import { ErrorApi, ErrorNotLoggedIn, Preloader } from 'src/components'
import { savedTokens } from 'src/auth'
import { useGetOrganization } from '../Info/queries'
import { TrackedSaveButton } from '../Info/TrackedInputs'
import { IamOrganization } from './IamOrganization'
import { toast } from 'sonner'

type Props = {
  organization: string
  username: string
}

function SAML(props: Props) {
  const { status, data, error, refetch } = useGetOrganization({
    organization: props.organization,
    username: props.username,
  })

  if (status === 'loading' || status === 'idle') {
    return <Preloader />
  }

  if (status === 'error') {
    return <ErrorApi message={error} onClick={refetch} />
  }

  if (data.setupStep !== 'finished') {
    toast.warning(`You didn't finish the setup yet.`)
    return null // FIXME: how to handle this case?
  }

  return (
    <>
      <div className="grid grid-cols-2 gap-6 px-2 mt-3">
        <IamOrganization
          iam_organization_usergroup={data.iam_organization_usergroup}
          iam_organization_policy_arn={data.iam_organization_policy_arn}
          iam_organization_admin_accessKey={
            data.iam_organization_admin_accessKey
          }
        />
      </div>

      <TrackedSaveButton
        organization={props.organization}
        username={props.username}
      />
    </>
  )
}

export default function ValidateInfo() {
  const [tokens] = savedTokens.useState(null)

  if (!tokens) {
    return <ErrorNotLoggedIn />
  }

  return <SAML organization={tokens.organization} username={tokens.username} />
}
